/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, DatePicker, message, Drawer, Form } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import FacilitiesSelect from '../../../components/Custom/FacilitiesSelect'

const { RangePicker } = DatePicker
// const dateFormat = 'YYYY/MM/DD'
const dateFormat = 'LLL'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			selectedFacility: null,
			didSelectFacility: false
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
		this.disabledDate = this.disabledDate.bind(this)
	}

	componentDidMount() {
		const { selectedReservation } = this.props
		if (selectedReservation) {
			this.setState({ 
				selectedFacility: { 
					uid: selectedReservation.reservation_uid,
					didSelectFacility: false 
				}
			})
		}
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { selectedFacility } = this.state
		const { form, AuthStore, saveReservation, onClose, selectedReservation } = this.props
		const { barangay_uid } = AuthStore
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}
			const from_date = moment(values.event_range[0]).format('YYYY-MM-DD HH:mm:ss')
			const to_date = moment(values.event_range[1]).format('YYYY-MM-DD HH:mm:ss')
			let params = Object.assign({}, values, { 
				barangay_uid, from_date, to_date,
				facility_uid: selectedFacility.uid
			})
			if (selectedReservation) {
				params = Object.assign({}, params, { reservation_uid: selectedReservation.uid })
			}
			console.log('params', params)

			message.loading({ key: 'set_reservation', content: 'Saving reservation, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveReservation(params).then((response) => {
					this.setState({ isSaving: false })
					message.success({ key: 'set_reservation', content: 'Reservation successfully saved.' })
					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving reservation')
					message.error({ key: 'set_reservation', content: err.message.replace('GraphQL error:', '') })
					resetFields()
				})
			})
		})
	}

	disabledDate (value) {
		return value < moment(new Date(), 'YYYY-MM-DD').subtract(1, 'day')
		// return value < moment(new Date(), 'YYYY-MM-DD')
	}

	render() {
		const { AuthStore, visible, onClose, form, selectedDate, selectedReservation } = this.props
		const { getFieldDecorator } = form
		const { barangay_uid } = AuthStore
		
		return (
			<Drawer
				title="Facilities Reservation Form"
				placement="right"
				// closable={false}
				onClose={onClose}
				visible={visible}
				width={'35%'}
				bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
			>
				<Form onSubmit={this.handleSubmit}>
					<Row>
						<Form.Item label='Facility'>
							{ getFieldDecorator('facility_uid', {
								initialValue: (selectedReservation) ? selectedReservation.facility_name : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}]
							})
							(
								<FacilitiesSelect 
									barangay_uid={barangay_uid} 
									onSelectedItem={(item) => {
										this.setState({ selectedFacility: Object.assign({}, item, { didSelectFacility: true }) })
									}}
								/>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Name of Requestor'>
							{ getFieldDecorator('name', {
								initialValue: (selectedReservation) ? selectedReservation.name : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Event Name'/>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Event name / Remarks'>
							{ getFieldDecorator('remarks', {
								initialValue: (selectedReservation) ? selectedReservation.remarks : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input.TextArea rows={4} placeholder='Enter an event name or any remarks'/>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Select Date of Reservation'>
							{ getFieldDecorator('event_range', {
								initialValue: (!selectedReservation && selectedDate) ? 
								    [moment(new Date(selectedDate), dateFormat), moment(new Date(selectedDate), dateFormat)] : 
								    [moment(new Date(selectedReservation.from_date), dateFormat), moment(new Date(selectedReservation.to_date), dateFormat)],
								rules: [{
									required: true,
									message: 'This field is required.'
								}]
							})
							(
								<RangePicker 
									showTime
									format={dateFormat}
									separator='to'
									style={{ width: '100%' }}
									disabledDate={this.disabledDate}
								/>
							)}
						</Form.Item>
					</Row>
				</Form>
				<div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div>
			</Drawer>
		)
	}
}

const SET_RESERVATION = gql`
    mutation setReservation($input: JSON) {
		setReservation(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-barangay-reservation' }),
	inject('AuthStore'),
	graphql(SET_RESERVATION, {
		props({ mutate }) {
			return {
				saveReservation(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['reservationByDate']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
